import { createFileRoute, redirect } from "@tanstack/react-router"
import { ANALYSIS_PRESET_GROUP_ID } from "~/components/collections/tabs/CollectionAnalysisTab"

export const Route = createFileRoute(
  "/_auth/demand-planning/fashion/$collectionId/_layout/performance",
)({
  beforeLoad: ({ params }) => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(
        `${ANALYSIS_PRESET_GROUP_ID}-preset-id`,
        JSON.stringify("performance"),
      )
    }
    throw redirect({
      to: "/demand-planning/fashion/$collectionId/analysis",
      params,
    })
  },
})
